import { DeviceType } from '../details/types';
import type { TelematicsTile } from './configuration/types';

export const POCKET_DRIVER_REGISTRATION_MAINTENANCE_FEATURE_TOGGLE_KEY =
    'asset-administration.pocket-driver-registration-maintenance.enabled';

export const isPocketDriverRegistrationMaintenanceEnabled = () =>
    typeof localStorage !== 'undefined' &&
    localStorage.getItem(POCKET_DRIVER_REGISTRATION_MAINTENANCE_FEATURE_TOGGLE_KEY) === 'true';

export const isPocketDriverRegistrationMaintenanceActive = (
    selectedTelematics: TelematicsTile | undefined
) =>
    selectedTelematics?.deviceType === DeviceType.POCKET_DRIVER_APP &&
    isPocketDriverRegistrationMaintenanceEnabled();
